import { ApiResponse } from 'app/types-shared';
import { RemoteAdminData } from 'app/infrastructure/remote-data/remote-data';
import { CodetableWireFormat } from 'app/infrastructure/ui/form/types-codetable';
import { endpoints } from './endpoints';
import { CodetableAccess } from './types-store';

export const api = {

  loadCodetableAccess: async (codetableId: number): Promise<CodetableAccess[]> => {
    const request = await new RemoteAdminData(endpoints.codetableAccess)
      .resource<ApiResponse<CodetableAccess[]>>()
      .filter({ id: codetableId })
      .single();
    return request.data;
  },

  loadHierarchy: async (): Promise<{ rootCodes: CodetableWireFormat[] }> => {
    const response = await new RemoteAdminData(endpoints.hierarchy)
      .resource<ApiResponse<{ rootCodes: CodetableWireFormat[] }>>()
      .all();

    return response.data;
  }
};
